import { render, staticRenderFns } from "./PreliminaryDatePickerQuestion.vue?vue&type=template&id=4a6ec291&scoped=true&"
import script from "./PreliminaryDatePickerQuestion.vue?vue&type=script&lang=js&"
export * from "./PreliminaryDatePickerQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ec291",
  null
  
)

export default component.exports